import type { IconButtonProps } from "@mui/material/IconButton";
import IconButton from "@mui/material/IconButton";
import type { ReactNode, Ref } from "react";

import styles from "./HeaderMenuIconButton.module.scss";

export type HeaderMenuIconButtonProps = IconButtonProps & {
  icon: ReactNode;
  ref?: Ref<HTMLAnchorElement>;
};

export function HeaderMenuIconButton({
  icon,
  ref,
  ...props
}: HeaderMenuIconButtonProps) {
  return (
    <IconButton ref={ref} className={styles.headerMenuIconButton} {...props}>
      {icon}
    </IconButton>
  );
}
